/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, disable, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : ACCOUNT EXISTING PAYMENTS : STYLES --------------- ++++++++++ */
export default theme =>({
    existingpayments: {
    }
});
